import Vue from 'vue';
import Router from 'vue-router';

import persisted from '@/helpers/modules/auth';

import Errors404 from '@/views/Errors/404.vue';

import ProposalsRead from '@sdk/views/Proposals/Read.vue';

Vue.use(Router);

function scroll(to, from) {
  if (to.name === from.name) {
    return null;
  }

  const data = {
    x: 0,
    behavior: 'smooth',
  };

  if (to.hash) {
    data.selector = to.hash;
  } else {
    data.y = 0;
  }

  return data;
}

const router = new Router({
  mode: 'history',
  scrollBehavior: scroll,
  routes: [{
    /*
     * AS TELAS DE CLIENTE SÃO DO EMBED, hospedadas pelo web (`web:customers/{new,edit,
     * show}.html.erb`). O perfil fica porque a proposta volta a ele POR NOME, das ações do
     * resumo do cliente (`@sdk/views/Customers/Actions.vue`).
     */
    path: '/customers',
    name: 'customers-read',
    meta: {
      external: true,
      title: 'Visualizar',
    },
    children: [{
      path: ':id',
      name: 'customers-read-profile',
      meta: {
        external: true,
        title: 'Visualizar',
      },
    }],
  }, {
    path: '/proposals',
    name: 'proposals-list',
    meta: {
      external: true,
      title: 'Propostas',
    },
  }, {
    /*
     * ESTAS DUAS NÃO SÃO ALCANÇADAS POR NADA: existem para `/proposals/:id` não casar com
     * elas. Essa rota TEM componente, então sem o registro "approved" e "new" viram `:id` e
     * o clique renderiza a tela de proposta em vez de sair para o servidor.
     */
    path: '/proposals/approved',
    name: 'proposals-approved',
    meta: {
      external: true,
      title: 'Aprovadas',
    },
  }, {
    path: '/proposals/new',
    name: 'proposals-new',
    meta: {
      external: true,
      title: 'Nova',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/new',
    name: 'proposal-attempts-new',
    meta: {
      external: true,
      title: 'Nova',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/:proposal_attempt_id/edit',
    name: 'proposal-attempts-edit',
    meta: {
      external: true,
      title: 'Editar',
    },
  }, {
    path: '/proposals/:id',
    alias: '/proposals/:id/comments',
    name: 'proposals-read',
    component: ProposalsRead,
    meta: {
      title: 'Visualizar',
    },
  }, {
    /*
     * O RESULTADO DA SIMULAÇÃO É DO EMBED, hospedado pelo web (`web:simulations/show.html.erb`).
     * A rota fica porque a proposta volta a ela POR NOME, ao editar uma tentativa simulada
     * (`@sdk/views/Proposals/Read/Information.vue`).
     */
    path: '/simulations/:uuid',
    name: 'simulations-read',
    meta: {
      external: true,
      title: 'Resultado',
    },
  }, {
    path: '*',
    name: 'errors-404',
    component: Errors404,
    meta: {
      title: 'Oops!',
      unauthenticated: true,
    },
  }],
});

router.beforeEach((to, from, next) => {
  const { meta } = to;

  if (/^http(s?):\/\//.test(to.path)) {
    window.open(to.path, '_blank');

    return next(false);
  }

  // Rota `external` é servida por fora: ao navegador vai o endereço INTEIRO, com a query.
  // Ela precisa existir em TRÊS casos: tela daqui que a alcance por nome, porque sem registro
  // `$router.push({ name })` estoura; SEGMENTO do caminho de uma tela que esta SPA renderiza,
  // porque a trilha do `App.vue` resolve segmento a segmento e o nível sem rota some calado; e
  // caminho literal que uma rota DINÂMICA com componente casaria se ele não existisse.
  // Para o atalho da barra lateral do `web` a flag é indiferente: ele devolve o clique ao
  // navegador tanto em rota `external` quanto em caminho sem registro.
  if (meta && meta.external) {
    window.location.href = to.fullPath;

    return next(false);
  }

  if ((!meta || !meta.unauthenticated) && (!persisted.token || !persisted.user)) {
    return next({ name: 'errors-404' });
  }

  return next();
});

router.afterEach(() => {
  if (!window.gtag) {
    return;
  }

  if (window.gtag.CREDERE_PWA_RENDERED) {
    window.gtag('event', 'page_view');
  } else {
    window.gtag.CREDERE_PWA_RENDERED = true;
  }
});

export default router;
